import http from "./index";

export default {
  /*获取网络课程详细信息*/
  getChaptersSectionsInfo: function(lesson_id, start_page) {
    return http.post("/index/getChaptersSectionsInfo", {
      lesson_id,
      start_page
    });
  }
};



// WEBPACK FOOTER //
// ./src/api/networkCourse.js